import React from 'react';
import { View, Image, StyleSheet } from 'react-native';
import { BText } from '../BText';
import { themeConfig } from '../../styles/themeConfig';
import IconTicketsWhite from './icons/ico-ticket-white.png';

export const RegisteredTag = () => {
  return (
    <View style={styles.container}>
      <Image style={styles.image} source={{ uri: IconTicketsWhite }} />
      <BText style={styles.text}>Registered</BText>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    height: 24,
    width: 103,
    paddingVertical: 5,
    paddingHorizontal: 8,
    backgroundColor: themeConfig.colors.brown,
    borderRadius: 4,
  },
  image: {
    marginRight: 4,
    marginTop: -2,
  },
  text: {
    fontSize: 14,
    fontWeight: '400',
    whiteSpace: 'nowrap',
    color: themeConfig.colors.white,
    textAlign: 'center',
  },
});
